import { Tooltip } from '@mui/material';
import { CellProps } from 'react-table';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';

import { MailboxContent } from '@work4all/models/lib/Classes/MailboxContent.entity';
import { MailAssignStatus } from '@work4all/models/lib/Enums/MailAssignStatus.enum';

import { useMailboxContentManagerContext } from '../context';

import { PickerTargetButton } from './components/PickerTargetButton';
import { SuggestionsFoundText } from './components/SuggestionsFoundText';
import { ProjectPickerWithSuggestions } from './ProjectPickerWithSuggestions';
import { projectAsString, ProjectText } from './ProjectText';

export function MailboxContentProjectCell(
  props: CellProps<MailboxContent, MailAssignStatus>
) {
  const mailboxContent = props.row.original;
  const id = mailboxContent.id;

  const context = useMailboxContentManagerContext();

  const item = context.state.itemsById[id];

  const value = item?.project ?? null;

  const isEditable =
    mailboxContent.assignStatus === MailAssignStatus.NOT_YET_ASSIGNED;

  const possibleProjects = mailboxContent.possibleProjects;

  return (
    <EntityPickerPopover
      picker={
        <ProjectPickerWithSuggestions
          value={value}
          onChange={(value) => {
            context.onProjectChange(id, value);
          }}
          suggestions={possibleProjects}
        />
      }
    >
      <Tooltip title={projectAsString(value)}>
        <PickerTargetButton disabled={!isEditable}>
          {value || !isEditable ? (
            <ProjectText project={value} />
          ) : (
            <SuggestionsFoundText suggestions={possibleProjects} />
          )}
        </PickerTargetButton>
      </Tooltip>
    </EntityPickerPopover>
  );
}
